    export interface IChangePasswordResponse {
        successful: boolean;
        message: string;
    }

    export class ChangePasswordResponse implements IChangePasswordResponse {
        successful: boolean;
        message: string;
    }